import React from "react";
import { Container } from "react-bootstrap";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="app-footer d-none d-md-block p-0 m-0">
      <Container fluid className="text-center py-3 m-0">
        <small className="text-muted">
          Copyright © {new Date().getFullYear()} EBOL. All rights reserved.
        </small>
      </Container>
    </footer>
  );
};

export default Footer;
